/** Runs cleanup on success, early return, synchronous throw and rejection. */
export async function withAsyncCleanup<T>(
  operation: () => Promise<T>,
  cleanup: () => void,
): Promise<T> {
  try {
    return await operation();
  } finally {
    cleanup();
  }
}
